import { requestToken } from "../api/request_methods";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/sub-admin`;

/**
 * Sub admins: created and owned by an Admin, sitting between the Admin
 * and the outlets / players they go on to create. Super Admin can list
 * and view; every write is the owning Admin's.
 */
class SubAdminServices {
  async list(page, limit, filter) {
    const query = `page=${page}&limit=${limit}&filter=${encodeURIComponent(filter || "")}`;
    return requestToken.get(`${API_ROUTE}/list?${query}`);
  }

  async detail(id) {
    return requestToken.get(`${API_ROUTE}/detail/${id}`);
  }

  async add(payload) {
    return requestToken.post(`${API_ROUTE}/add`, payload);
  }

  async update(payload) {
    return requestToken.post(`${API_ROUTE}/update`, payload);
  }

  async setStatus(id, isActive) {
    return requestToken.post(`${API_ROUTE}/status`, { id, is_active: isActive ? 1 : 0 });
  }

  /** type CREDIT (Admin -> sub admin) or DEBIT (back to Admin); whole rupees. */
  async wallet(payload) {
    return requestToken.post(`${API_ROUTE}/wallet`, payload);
  }

  async remove(id) {
    return requestToken.del(`${API_ROUTE}/delete?id=${id}`);
  }
}

export default SubAdminServices;
